module.exports = __webpack_public_path__ + "img/moscow.72653638.png";